export * from './courses.service';
import { CoursesService } from './courses.service';
export * from './courses.serviceInterface'
export * from './groups.service';
import { GroupsService } from './groups.service';
export * from './groups.serviceInterface'
export * from './imports.service';
import { ImportsService } from './imports.service';
export * from './imports.serviceInterface'
export * from './leaderboards.service';
import { LeaderboardsService } from './leaderboards.service';
export * from './leaderboards.serviceInterface'
export * from './mobile.service';
import { MobileService } from './mobile.service';
export * from './mobile.serviceInterface'
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './notifications.serviceInterface'
export * from './pairings.service';
import { PairingsService } from './pairings.service';
export * from './pairings.serviceInterface'
export * from './playerTypeLinks.service';
import { PlayerTypeLinksService } from './playerTypeLinks.service';
export * from './playerTypeLinks.serviceInterface'
export * from './players.service';
import { PlayersService } from './players.service';
export * from './players.serviceInterface'
export * from './playoffs.service';
import { PlayoffsService } from './playoffs.service';
export * from './playoffs.serviceInterface'
export * from './pointsRaces.service';
import { PointsRacesService } from './pointsRaces.service';
export * from './pointsRaces.serviceInterface'
export * from './purses.service';
import { PursesService } from './purses.service';
export * from './purses.serviceInterface'
export * from './reference.service';
import { ReferenceService } from './reference.service';
export * from './reference.serviceInterface'
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './reports.serviceInterface'
export * from './scorecards.service';
import { ScorecardsService } from './scorecards.service';
export * from './scorecards.serviceInterface'
export * from './systemInfo.service';
import { SystemInfoService } from './systemInfo.service';
export * from './systemInfo.serviceInterface'
export * from './teams.service';
import { TeamsService } from './teams.service';
export * from './teams.serviceInterface'
export * from './tournaments.service';
import { TournamentsService } from './tournaments.service';
export * from './tournaments.serviceInterface'
export * from './tours.service';
import { ToursService } from './tours.service';
export * from './tours.serviceInterface'
export * from './webhooks.service';
import { WebhooksService } from './webhooks.service';
export * from './webhooks.serviceInterface'
export const APIS = [CoursesService, GroupsService, ImportsService, LeaderboardsService, MobileService, NotificationsService, PairingsService, PlayerTypeLinksService, PlayersService, PlayoffsService, PointsRacesService, PursesService, ReferenceService, ReportsService, ScorecardsService, SystemInfoService, TeamsService, TournamentsService, ToursService, WebhooksService];
